import Icon from '../components/Icon.vue'

Icon.register({
  moon: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M283.2 512c-141.5 0-256-114.7-256-256 0-141.5 114.7-256 256-256 13 0 34 1.9 46.8 4.3 11 2 13.4 16.7 3.8 22.2-62.8 35.8-101.5 102.2-101.5 174.4 0 125.4 114.1 220.6 238.3 197 10.9-2.1 18.6 10.6 11.6 19.3-47.8 58.9-119.9 94.8-198.9 94.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/moon.js
// module id = 1584
// module chunks = 0